(function () {
  function init() {
    var form = document.getElementById('contact-main__form');
    if (!form) return;

    if (form.dataset.contactFormBound === 'true') return;
    form.dataset.contactFormBound = 'true';

    var submitButton = form.querySelector('button[type="submit"]');
    var messageWrap = form.querySelector('.contact-main__form-item--message');
    var successEl = form.querySelector('#success-message');
    var errorEl = form.querySelector('#error-message');
    var messageField = form.querySelector('#message');

    var defaultErrorHtml = errorEl ? errorEl.innerHTML : '';

    var submitting = false;

    function showError(msg) {
      if (errorEl) {
        if (typeof msg === 'string') {
          errorEl.textContent = msg;
        } else {
          errorEl.innerHTML = defaultErrorHtml;
        }
        errorEl.style.display = '';
      }
      if (successEl) successEl.style.display = 'none';
      if (messageWrap) messageWrap.style.display = '';
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (submitting) return;

      if (messageWrap) messageWrap.style.display = 'none';
      if (successEl) successEl.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';

      var publicKey = form.getAttribute('data-bp-key');
      if (!publicKey) {
        console.warn('[contact-form] Missing data-bp-key.');
        showError('Form is not configured correctly. Please try again later.');
        return;
      }
      if (typeof Botpoison === 'undefined') {
        console.error('[contact-form] Botpoison is not loaded.');
        showError('Bot protection service unavailable. Please try again later.');
        return;
      }

      var messageValue = (messageField && messageField.value) || '';
      messageValue = messageValue.trim();
      if (messageValue === '') {
        showError('Please enter a valid message.');
        return;
      }

      submitting = true;
      form.classList.add('is-loading');
      if (submitButton) submitButton.disabled = true;

      var botpoison;
      try {
        botpoison = new Botpoison({ publicKey: publicKey });
      } catch (e) {
        console.error('[contact-form]', e);
        showError('Bot protection service unavailable. Please try again later.');
        submitting = false;
        form.classList.remove('is-loading');
        if (submitButton) submitButton.disabled = false;
        return;
      }

      botpoison
        .challenge()
        .then(function (result) {
          var formData = new FormData(form);
          var data = {};
          formData.forEach(function (value, key) {
            data[key] = value;
          });
          data._botpoison = result.solution;

          return fetch(form.action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then(function (response) {
              if (response && response.ok) {
                if (messageWrap) messageWrap.style.display = '';
                if (successEl) successEl.style.display = '';
                if (errorEl) errorEl.style.display = 'none';
                form.reset();
                document.body.classList.add('contact-form-sent');
              } else {
                showError();
              }
            })
            .catch(function (err) {
              console.error('[contact-form]', err);
              showError();
            });
        })
        .catch(function (err) {
          console.error('[contact-form]', err);
          showError('Bot protection failed. Please try again.');
        })
        .finally(function () {
          submitting = false;
          form.classList.remove('is-loading');
          if (submitButton) submitButton.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
